// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Cart.module.css */

.OrderList_container__x0HQz {
  font-family: Arial, sans-serif;
  width: 100%;
}

.OrderList_table__XORZG {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.OrderList_table__XORZG th, td {
  padding: 10px;
  /* border-bottom: 1px solid #ddd; */
}

.OrderList_table__XORZG th {
  background-color: #f8f8f8;
  font-weight: bold;
  font-size: 16px;
}

.OrderList_table__XORZG tfoot td {
  font-weight: bold;
}

.OrderList_image__EbPvj {
  width: 50px;
  height: 50px;
  margin-right: 10px;
  vertical-align: middle;
}

.OrderList_summary__XMN46 {
  text-align: right;
}

.OrderList_summary__XMN46 p {
  margin: 5px 0;
}

.OrderList_summary__XMN46 .OrderList_total__IZBO4 {
  font-weight: bold;
  font-size: 1.2em;
}

.OrderList_centered__pidYT {
  text-align: center;
}

.OrderList_right__ty8hE {
  text-align: right;
}

.OrderList_left__pMN7o {
  text-align: left;
}

.OrderList_productName__urqRe {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/ShoppingChart/Address/OrderList/OrderList.module.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["/* Cart.module.css */\n\n.container {\n  font-family: Arial, sans-serif;\n  width: 100%;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.table th, td {\n  padding: 10px;\n  /* border-bottom: 1px solid #ddd; */\n}\n\n.table th {\n  background-color: #f8f8f8;\n  font-weight: bold;\n  font-size: 16px;\n}\n\n.table tfoot td {\n  font-weight: bold;\n}\n\n.image {\n  width: 50px;\n  height: 50px;\n  margin-right: 10px;\n  vertical-align: middle;\n}\n\n.summary {\n  text-align: right;\n}\n\n.summary p {\n  margin: 5px 0;\n}\n\n.summary .total {\n  font-weight: bold;\n  font-size: 1.2em;\n}\n\n.centered {\n  text-align: center;\n}\n\n.right {\n  text-align: right;\n}\n\n.left {\n  text-align: left;\n}\n\n.productName {\n  font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `OrderList_container__x0HQz`,
	"table": `OrderList_table__XORZG`,
	"image": `OrderList_image__EbPvj`,
	"summary": `OrderList_summary__XMN46`,
	"total": `OrderList_total__IZBO4`,
	"centered": `OrderList_centered__pidYT`,
	"right": `OrderList_right__ty8hE`,
	"left": `OrderList_left__pMN7o`,
	"productName": `OrderList_productName__urqRe`
};
export default ___CSS_LOADER_EXPORT___;
